module.exports = __webpack_public_path__ + "static/media/claim-process.c108012c.aif";